var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:_vm.$vuetify.breakpoint.smAndUp ? 'pl-8' : ''},[_c('v-col',{attrs:{"cols":_vm.$vuetify.breakpoint.xsOnly ? 12 : 4}},[_c('ProfileNavigation',{attrs:{"selected-tab":"user-info"}})],1),(_vm.$vuetify.breakpoint.smAndUp)?_c('v-col',[_c('UserInfo')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }